import React, { useRef, useState } from 'react';
import { TextField, Button, Typography, Box, Grid, InputAdornment } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../Auth/AuthContext';
import { useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';

import { Backdrop, CircularProgress } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const LoginComponent = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  const [openBackDrop, setOpenBackDrop] = useState(false);
  const submitRef = useRef(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorUsername, setErrorUsername] = useState('');
  const [errorPassword, setErrorPassword] = useState('');

  const handleLogin = async (event) => {
    event?.preventDefault();
    if (submitRef.current || openBackDrop) return;
    // Resetea los mensajes de error
    setErrorUsername('');
    setErrorPassword('');

    // Validación de campos vacíos
    if (username === '' || password === '') {
      if (username === '') {
        setErrorUsername('El nombre de usuario es obligatorio');
      }
      if (password === '') {
        setErrorPassword('La contraseña es obligatoria');
      }
      return;
    }
    submitRef.current = true;
    setOpenBackDrop(true);
  
    try {
      const response = await fetch(`${API_URL}/login/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nombre: username,
          contraseña: password,
        }),
      });
      const data = await response.json();
  
      if (data.success) {
        login(data.usuario);
        navigate('/Menu');
      } else {
        // Asigna los errores según el mensaje recibido
        if (data.error.includes('Usuario')) {
          setErrorUsername(data.error);
        }
        if (data.error.includes('Contraseña')) {
          setErrorPassword(data.error);
        }
      }
    } catch (error) {
      console.error('Error en la autenticación:', error);
      setErrorUsername('Error de conexión');
      setErrorPassword('Intenta de nuevo');
    } finally {
      submitRef.current = false;
      setOpenBackDrop(false);
    }
  };

  return (
    <Grid
      container
      direction="column"
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: 2,
      }}
    >
      <Backdrop
        open={openBackDrop}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid
        item
        sx={{
          width: '100%',
          maxWidth: 400,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: { xs: '15vh', sm: '18vh', md: '20vh' },
        }}
      >
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{
            marginBottom: 2,
            whiteSpace: 'nowrap',
            fontSize: 'clamp(2rem, 3vw, 2.5rem)',
            fontFamily: 'Bebas Neue, sans-serif',
            fontWeight: 'bold',
          }}
        >
          INICIAR SESIÓN
        </Typography>

        <Box component="form" onSubmit={handleLogin} display="flex" flexDirection="column" alignItems="center" sx={{ width: '75%' }}>
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{
              whiteSpace: 'nowrap',
              fontSize: 'clamp(1rem, 1.5vw, 1rem)',
              fontFamily: 'Bebas Neue, sans-serif',
              fontWeight: 'bold',
              color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : theme.palette.grey[700]
            }}
          >
            Parqueadero Los Kioskitos
          </Typography>

          <TextField
            label="Nombre De Usuario"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            required
            onChange={(e) => setUsername(e.target.value)}
            error={!!errorUsername}
            helperText={errorUsername}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
          />
          
          <TextField
            label="Contraseña"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            error={!!errorPassword}
            helperText={errorPassword}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant={theme.palette.mode === 'dark' ? "outlined" : "contained"}
            color="primary"
            fullWidth
            size="large"
            sx={{ mt: 2 }}
            type="submit"
            disabled={openBackDrop}
          >
            Iniciar Sesión
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default LoginComponent;
